const theme = {
  colors: {
    lightGrey: "#9c95a6",
    darkGrey: "#403547",
    yellow: "#ffd210",
    bgLight: "#f8f3ef",
  },

  fonts: {
    HKGrotesk:
      "HK Grotesk, San Francisco, SF Pro Text, -apple-system, system-ui, BlinkMacSystemFont, Roboto, Helvetica Neue, Segoe UI, Arial, sans-serif",
    Lato: "Lato, Lucida Grande, Tahoma, sans-serif",
    ApercuRegular: "Apercu Regular, Lucida Grande, Tahoma, sans-serif",
    ApercuMono: "Apercu Mono, Monaco, monospace",
  },

  fontSizes: {
    xxxl: "5rem",
    xxl: "3rem",
    xl: "2rem",
    lg: "1.5rem",
    md: "1.25rem",
    sm: "1rem",
    xs: "0.75rem",
    xxs: "0.6rem",
  },

  easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  transition: "all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1)",
}

export default theme
